/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceStatusFilter } from './PriceStatusFilter';
import {
    PriceStatusFilterFromJSON,
    PriceStatusFilterFromJSONTyped,
    PriceStatusFilterToJSON,
    PriceStatusFilterToJSONTyped,
} from './PriceStatusFilter';
import type { ProductStatusFilter } from './ProductStatusFilter';
import {
    ProductStatusFilterFromJSON,
    ProductStatusFilterFromJSONTyped,
    ProductStatusFilterToJSON,
    ProductStatusFilterToJSONTyped,
} from './ProductStatusFilter';

/**
 * 
 * @export
 * @interface CreatePriceSessionQueryParametersDto
 */
export interface CreatePriceSessionQueryParametersDto {
    /**
     * 
     * @type {Date}
     * @memberof CreatePriceSessionQueryParametersDto
     */
    validFromDate: Date;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreatePriceSessionQueryParametersDto
     */
    priceUnitIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreatePriceSessionQueryParametersDto
     */
    productIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePriceSessionQueryParametersDto
     */
    themeIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePriceSessionQueryParametersDto
     */
    groupIds?: Array<string> | null;
    /**
     * 
     * @type {ProductStatusFilter}
     * @memberof CreatePriceSessionQueryParametersDto
     */
    productStatus?: ProductStatusFilter;
    /**
     * 
     * @type {PriceStatusFilter}
     * @memberof CreatePriceSessionQueryParametersDto
     */
    priceStatus?: PriceStatusFilter;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePriceSessionQueryParametersDto
     */
    onlyZeroPrices: boolean;
}

/**
 * Check if a given object implements the CreatePriceSessionQueryParametersDto interface.
 */
export function instanceOfCreatePriceSessionQueryParametersDto(value: object): value is CreatePriceSessionQueryParametersDto {
    if (!('validFromDate' in value) || value['validFromDate'] === undefined) return false;
    if (!('onlyZeroPrices' in value) || value['onlyZeroPrices'] === undefined) return false;
    return true;
}

export function CreatePriceSessionQueryParametersDtoFromJSON(json: any): CreatePriceSessionQueryParametersDto {
    return CreatePriceSessionQueryParametersDtoFromJSONTyped(json, false);
}

export function CreatePriceSessionQueryParametersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePriceSessionQueryParametersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'validFromDate': (new Date(json['validFromDate'])),
        'priceUnitIds': json['priceUnitIds'] == null ? undefined : json['priceUnitIds'],
        'productIds': json['productIds'] == null ? undefined : json['productIds'],
        'themeIds': json['themeIds'] == null ? undefined : json['themeIds'],
        'groupIds': json['groupIds'] == null ? undefined : json['groupIds'],
        'productStatus': json['productStatus'] == null ? undefined : ProductStatusFilterFromJSON(json['productStatus']),
        'priceStatus': json['priceStatus'] == null ? undefined : PriceStatusFilterFromJSON(json['priceStatus']),
        'onlyZeroPrices': json['onlyZeroPrices'],
    };
}

export function CreatePriceSessionQueryParametersDtoToJSON(json: any): CreatePriceSessionQueryParametersDto {
    return CreatePriceSessionQueryParametersDtoToJSONTyped(json, false);
}

export function CreatePriceSessionQueryParametersDtoToJSONTyped(value?: CreatePriceSessionQueryParametersDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validFromDate': (formatDateOnly(value['validFromDate'])),
        'priceUnitIds': value['priceUnitIds'],
        'productIds': value['productIds'],
        'themeIds': value['themeIds'],
        'groupIds': value['groupIds'],
        'productStatus': ProductStatusFilterToJSON(value['productStatus']),
        'priceStatus': PriceStatusFilterToJSON(value['priceStatus']),
        'onlyZeroPrices': value['onlyZeroPrices'],
    };
}

